import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const StickyLogo = ({setToggled, toggled, url="/zequencer-logo-hiero.svg"}) => { 
    return (
        <img onClick={() => setToggled(!toggled)} className={toggled ? "logo-hiero toggled" : "logo-hiero"} src={url}/>
    );
};

export default StickyLogo;
